




import { Vue, Component, Prop, Watch} from 'division-marker';
import 'vue-loading-overlay/dist/vue-loading.css';

@Component({components: {}, mixins:[]})
export default class WtApp extends Vue {
  loaded = false

  async mounted(){
    console.debug('begin WtApp mounted')
    const reses = await Promise.all([
      this.$store.dispatch('consts/load'),
      this.$store.dispatch('current_user/load'),
      this.$store.dispatch('wt/load')
    ]);
    console.debug('loaded WtApp mounted')
    //定数ロード
    // this.$store.dispatch('consts/load')
    // ログイン情報の連携
    const current_user = reses[1]
    // alert
    if(current_user == null && !this.$route.fullPath.match("/sign_in")){
      // window.location.href = '#/sign_in';
    }
    this.loaded = true;
  }
};
